import { Button, Icon, Popup, Table } from 'semantic-ui-react';

import style from './AddProducts.module.css';
import { FormEvent, useState } from 'react';
import Moment from 'react-moment';
import { defaultDateTimeFormat } from '@vidende/constants';
import * as React from 'react';
import { PartyProduct, Product } from '@vidende/contracts';
import { ErrorRenderer } from './ErrorRenderer';
import { ApiError } from '@vidende/store/apiError';
import type { SerializedError } from '@reduxjs/toolkit';
import Text from './fields/Text';
interface Props {
    onClose?: (event: React.MouseEvent<HTMLElement>) => void;
    onAdd?: (product: { added: boolean } & PartyProduct) => void;
    onProductInfo?: (product: Product) => void;
    products: ({ added: boolean } & PartyProduct)[];
    isLoading?: boolean;
    error?: ApiError | SerializedError;
}

export const AddProducts = ({
    onProductInfo,
    onClose,
    onAdd,
    isLoading,
    products,
    error,
}: Props) => {
    const [productName, setProductName] = useState('');
    return (
        <div className={style.Root}>
            {products.length > 0 && (
                <div className={style.TableContainer}>
                    <Text
                        label="Product Name"
                        value={productName}
                        onChange={(_, { value }) => setProductName(value)}
                        name="productName"
                        debounce={false}
                    />
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>
                                    Product Name
                                </Table.HeaderCell>
                                <Table.HeaderCell collapsing>
                                    Class
                                </Table.HeaderCell>
                                <Table.HeaderCell collapsing></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {products
                                .filter((product) =>
                                    product.executionTicketSetlabel
                                        ?.toLowerCase()
                                        .includes(productName.toLowerCase()),
                                )
                                .sort((a, b) =>
                                    a.executionTicketSetlabel.localeCompare(
                                        b.executionTicketSetlabel,
                                    ),
                                )
                                .map((product, index) => {
                                    return (
                                        <Table.Row key={index}>
                                            <Table.Cell>
                                                {
                                                    product.executionTicketSetlabel
                                                }{' '}
                                                {onProductInfo && (
                                                    <Icon
                                                        name="info circle"
                                                        size="large"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() =>
                                                            onProductInfo({
                                                                executionId:
                                                                    product.executionId,
                                                                ticketSetId:
                                                                    product.executionTicketSetId,
                                                                executionTicketId:
                                                                    product.executionTicketId,
                                                                productName:
                                                                    product.executionTicketSetlabel,
                                                                entityId:
                                                                    product.entityId,
                                                                umr: product.productReference,
                                                                class: product.productClass,
                                                                carrier:
                                                                    'carrier',
                                                                added: product.added,
                                                                type: 'EXECUTION',
                                                            })
                                                        }
                                                    />
                                                )}
                                            </Table.Cell>
                                            <Table.Cell collapsing>
                                                {product.productClass}
                                            </Table.Cell>
                                            <Table.Cell collapsing>
                                                {product.added ? (
                                                    <Icon
                                                        color="green"
                                                        name="check"
                                                    />
                                                ) : (
                                                    <Popup
                                                        on="click"
                                                        content={
                                                            <>
                                                                <p>
                                                                    I confirm
                                                                    that my firm
                                                                    <br />
                                                                    distributes
                                                                    this
                                                                    product.
                                                                </p>
                                                                <Button
                                                                    loading={
                                                                        isLoading
                                                                    }
                                                                    disabled={
                                                                        isLoading
                                                                    }
                                                                    icon
                                                                    onClick={() =>
                                                                        onAdd!(
                                                                            product,
                                                                        )
                                                                    }
                                                                >
                                                                    <Icon
                                                                        name="check"
                                                                        color="green"
                                                                    />
                                                                </Button>
                                                            </>
                                                        }
                                                        trigger={
                                                            <Button
                                                                loading={
                                                                    isLoading
                                                                }
                                                                disabled={
                                                                    isLoading
                                                                }
                                                                icon
                                                            >
                                                                <Icon name="add circle" />
                                                            </Button>
                                                        }
                                                    />
                                                )}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                        </Table.Body>
                    </Table>

                    {error && <ErrorRenderer error={error} />}
                </div>
            )}
        </div>
    );
};
